// eslint-disable-next-line import/no-extraneous-dependencies
import { EventContext, setup, trackEntityPageViewEvent, trackPageViewEvent } from '@sitecore-search/data';

const SitecoreSearchPageTracker = () => {
    const pageTracking = window.sitecorePageTracking || undefined;

    if (typeof window === 'undefined' || pageTracking === undefined) {
        return;
    }
    const { env, customerKey, apiKey, pageType, id = '', url, entityContent } = pageTracking;

    setup({
        env,
        customerKey,
        apiKey
    });

    const eventContext = EventContext.get();
    eventContext.setBrowser({ user_agent: navigator.userAgent });
    eventContext.setPage({ uri: url });

    if (id) {
        trackEntityPageViewEvent(entityContent, { items: [{ id }] });
    } else {
        trackPageViewEvent(pageType);
    }
};

document.addEventListener('DOMContentLoaded', () => {
    // Initialize your code here
    SitecoreSearchPageTracker();
});
